"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentNotificationEvent = void 0;
var AppointmentNotificationEvent;
(function (AppointmentNotificationEvent) {
    AppointmentNotificationEvent["Scheduled"] = "Scheduled";
    AppointmentNotificationEvent["AppointmentConfirmation"] = "AppointmentConfirmation";
    AppointmentNotificationEvent["AppointmentReminder"] = "AppointmentReminder";
    AppointmentNotificationEvent["AppointmentRescheduleRequested"] = "AppointmentRescheduleRequested";
    AppointmentNotificationEvent["AppointmentConfirmed"] = "AppointmentConfirmed";
    AppointmentNotificationEvent["AppointmentCancelation"] = "AppointmentCancelation";
    AppointmentNotificationEvent["ArrivalConfirmation"] = "ArrivalConfirmation";
    AppointmentNotificationEvent["AppointmentFollowup"] = "AppointmentFollowup";
})(AppointmentNotificationEvent = exports.AppointmentNotificationEvent || (exports.AppointmentNotificationEvent = {}));
//# sourceMappingURL=SendAppointmentNotificationJobInput.js.map